const Config = {
  API_ROOT: 'https://iwan.wanchain.org/api/',
  RECAPTCHA_SITE_KEY: '6LeyP5gUAAAAAJ7vMjI6YvKZYRZ9Kf8twTcSqX4j',
}

module.exports = Config



// WEBPACK FOOTER //
// ./src/config.js